export default "__VITE_PUBLIC_ASSET__b3ae5c08__"